import { useRouteError } from 'react-router-dom';

import { MainErrorFallback } from '@/components/errors/main-error-fallback';
import { PlanRequiredError } from '@/features/tournaments/api/get-tournament';

const PlanRequiredPage = () => {
  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center px-6 text-center text-gray-700"
      role="alert"
    >
      <h1 className="text-lg font-semibold">
        Live scoreboards aren&apos;t in this tournament&apos;s plan
      </h1>
      <p className="mt-2 max-w-md text-sm text-gray-500">
        Scoreboards and stream overlays come with the Small plan and up. To turn
        them on, the organizer can upgrade under the tournament&apos;s Billing
        settings in Scored.
      </p>
    </div>
  );
};

export const RouteError = () => {
  const error = useRouteError();

  if (error instanceof PlanRequiredError) {
    return <PlanRequiredPage />;
  }

  return <MainErrorFallback />;
};
